import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Utils } from '../fork-common-controls/utils.service';
import { LoginRedirectServiceComponent } from '../services/login-redirect/login-redirect.service';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { BorrowerIdentifyingInfo, LoanFacts } from '../models/index';
import MortgageProviderTypeEnum = LoanFacts.MortgageProviderTypeEnum;

@Component({
  selector: 'ld-my-loan',
  template: `
    <div class="loan" (click)="onClick($event)">
      {{ loanType }} Loan# {{ displayLoanId }}
      <div class="loan-description">{{ formattedAddress }}</div>
    </div>
  `
})
export class MyLoanComponent {
  @Output() private clickLoan = new EventEmitter();
  @Input() private set loan(value: LoanFacts) {
    this._loan = value;
    this.setDisplayFields(this._loan);
  }

  private get loan() {
    return this._loan;
  }

  private _loan: LoanFacts;
  public displayLoanId: string;
  public loanType: string;
  public formattedAddress: string;

  constructor(
    private directorService: LoginRedirectServiceComponent,
    private dashboardService: DashboardService) {}

  public onClick(e: MouseEvent, showSidePanel: boolean = false): void {
    let matchedBorrower: BorrowerIdentifyingInfo;
    let matchedBorrowerId: string;

    const borrowers = this.loan.borrowers;
    const { dashboardNameToFilterBy, dashboardSsnToFilterBy }  = this.dashboardService;

    if (dashboardNameToFilterBy) {
      matchedBorrower = borrowers.find(b => `${ b.firstName } ${ b.lastName }` === dashboardNameToFilterBy);
    } else if (dashboardSsnToFilterBy) {
      matchedBorrower = borrowers.find(b => b.code === dashboardSsnToFilterBy);
    } else {
      matchedBorrower = borrowers[0];
    }

    matchedBorrowerId = matchedBorrower ? matchedBorrower.borrowerID : null;

    this.directorService.directByLoanFacts(this.loan, matchedBorrowerId);
    this.clickLoan.emit(showSidePanel);
  }

  private setDisplayFields(loan: LoanFacts) {
    this.displayLoanId = loan.displayLoanId;
    this.formattedAddress = Utils.flattenAddressModel(loan.subjectAddress || {});

    switch (loan.mortgageProviderType) {
      case MortgageProviderTypeEnum.MortgageDirect:
      case MortgageProviderTypeEnum.MortgageRetail:
        this.loanType = 'Mortgage';
        break;
      case MortgageProviderTypeEnum.PersonalLoans:
        this.loanType = 'Personal';
        break;
      default:
        this.loanType = '';
    }
  }
}
